export default {
    // demo
    hello: 'Welcome to Your Vue.js App！',
    // 页签
    tagsView: {
        closeCurrent: 'Close Current',
        closeOther: 'Close Other',
        closeAll: 'Close All',
    },
};
